import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ItemType, FunctionsAvailable } from '../../formulario/request.model';
import { ItemEvent, FormEvent } from '../../item/item.model';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Asociacion, AsociadosService, Cargo, CargosService, HistoricoAsociado, ResponseAsociaciones, ResponseAsociados, ResponseCargos, ResponseHistoricosAsociados } from '../../../../api';
import { forkJoin } from 'rxjs';
import { RestablecerPasswordComponent } from '../../restablecer-password/restablecer-password.component';
import { PermisosService } from '../../../services/permisos.service';
import { Field } from '../../formulario/field.model';
import { FORM_BUTTONS } from '../../formulario/form-buttons.config';
import { FormButtonType } from '../../formulario/formButtonType.enum';
import { FormularioService } from '../../../services/formulario.service';
import { FormularioComponent } from '../../formulario/formulario.component';
import { AlertService } from '../../alert/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ListadoComponent } from '../../listado/listado.component';
import { HistoricoShow } from '../../historico/historico.component';
import { tieneFoto } from '../../../core/foto.util';
import { environment } from '../../../../environments/environment';
import { AsociadosListadoService } from '../../../services/asociados-listado.service';
import { NavegacionService } from '../../../services/navegacion.service';
import { MigasService } from '../../../services/migas.service';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { TabsNavDirective } from '../../ui/tabs-nav.directive';

export enum ViewModeAsociado {
  PERSONAL = 'personal',
  CONTACT = 'contact',
  ASOCIACIONES = 'asociaciones',
  CHANGE_PASSWORD = 'change_password',
  HISTORICO = 'historico'
}

@Component({
  selector: 'app-asociado',
  standalone: true,
  imports: [CommonModule, RestablecerPasswordComponent, FormularioComponent, ReactiveFormsModule, ListadoComponent, SpinnerComponent, TabsNavDirective],
  templateUrl: './asociado.component.html',
  styleUrl: './asociado.component.scss'
})
export class AsociadoComponent {
  ViewModeAsociado = ViewModeAsociado;
  ItemType = ItemType;
  FunctionsAvailable = FunctionsAvailable;
  filesBasePath = environment.FILES_BASE_PATH;
  tieneFoto = tieneFoto;

  loading = true;
  /** Mensaje de error de carga: la ficha muestra un panel con acciones, nunca una pantalla en blanco. */
  error = '';

  @Input()
  item!: any;

  @Input()
  parent?: any;

  @Output()
  openItem = new EventEmitter<ItemEvent | FormEvent>();

  @Output()
  back = new EventEmitter<any>();

  viewMode: ViewModeAsociado = ViewModeAsociado.PERSONAL;
  preUrl: string = '';

  asociaciones: Asociacion[] = [];
  asociacionesToShow: Asociacion[] = this.asociaciones;

  cargos: HistoricoShow[] = [];

  searchControl = new FormControl();

  showEdit = false;
  buttons = [
    FORM_BUTTONS[FormButtonType.Borrar],
    FORM_BUTTONS[FormButtonType.Cancelar],
  ]
  fields: Field[] = [];
  type!: ItemType;

  constructor(
    private asociadosService: AsociadosService,
    private asociadosListado: AsociadosListadoService,
    private nav: NavegacionService,
    private migas: MigasService,
    protected permisos: PermisosService,
    private formularioService: FormularioService,
    private route: ActivatedRoute,
    protected router: Router,
    private alertService: AlertService
  ) {

  }

  /** Restablecimiento administrativo de la contraseña de una persona (permiso global; la API lo vuelve a exigir). */
  get puedeRestablecer(): boolean { return this.permisos.tieneGlobal('contrasenas:restablecer'); }

  ngOnInit() {
    this.preUrl = this.route.snapshot.url[0]?.path ?? 'asociados';
    this.cargar();
  }

  /**
   * La ruta lleva el ID interno (/asociados/<id>, el que usan las tarjetas). Un enlace antiguo con DNI/NIF
   * (/asociados/<NIF>) se resuelve por documento y la URL queda con el ID. Nunca se descarga la lista de asociados.
   */
  cargar() {
    const param = (this.route.snapshot.paramMap.get('id') ?? '').trim();
    this.error = '';
    this.loading = true;
    if (/^\d+$/.test(param) && Number(param) > 0) {
      this.loadData(Number(param));
    } else if (param) {
      this.resolverPorDocumento(param);
    } else if (this.item?.id) {
      this.loadData(Number(this.item.id));
    } else {
      this.fallar('Ese asociado no existe.');
    }
  }

  private resolverPorDocumento(documento: string) {
    this.asociadosListado.buscarPorDocumento(documento).subscribe({
      next: res => {
        const id = Number(res?.asociados?.[0]?.id);
        if (!id) {
          this.fallar('Ese asociado no existe.');
          return;
        }
        this.router.navigate(['/asociados', id], { replaceUrl: true });
        this.loadData(id);
      },
      error: (err: HttpErrorResponse) => this.fallar(this.mensajeError(err))
    });
  }

  loadData(id: number) {
    if (!Boolean(id) || id === -1) {
      this.fallar('Ese asociado no existe.');
      return;
    }
    const asociacionesAsociado = this.asociadosService.getAsociacionesByAsociado(id);
    const asociadoData = this.asociadosService.asociadosGetById(id);
    const cargosData = this.asociadosService.getHistoricoByAsociado(id);
    forkJoin([asociacionesAsociado, asociadoData, cargosData]).subscribe({
      next: ([asociaciones, asociado, cargos]: [ResponseAsociaciones, ResponseAsociados, ResponseHistoricosAsociados]) => {
        const encontrado = asociado.status?.status === 200 ? asociado.asociados?.[0] : undefined;
        if (!encontrado) {
          this.fallar('No se han podido cargar los datos del asociado.');
          return;
        }
        this.item = encontrado;
        this.migas.etiqueta('asociado:' + id, [encontrado.nombre, encontrado.apellidos].filter(Boolean).join(' '));
        if (asociaciones.status?.status === 200) {
          this.asociaciones = (asociaciones.asociaciones ?? []).sort((a, b) => {
            if (a.nombre > b.nombre) {
              return 1;
            } else if (a.nombre < b.nombre) {
              return -1;
            } else {
              return 0;
            }
          });
          this.asociacionesToShow = this.asociaciones;
        }
        if (cargos.status?.status === 200) {
          this.cargos = this.agruparPorEjercicio(cargos.historico ?? []);
        }
        this.loading = false;
      },
      error: (err: HttpErrorResponse) => this.fallar(this.mensajeError(err))
    });
  }

  private fallar(mensaje: string) {
    this.error = mensaje;
    this.loading = false;
    this.alertService.danger(mensaje, 5000);
  }

  private mensajeError(err: HttpErrorResponse): string {
    if (err?.status === 404) return 'Ese asociado no existe.';
    if (err?.status === 403) return 'No tienes permiso para ver este asociado.';
    if (err?.status === 401) return 'Tu sesión ha caducado. Vuelve a iniciar sesión.';
    const detalle = err?.error?.status?.message;
    return 'Se produjo un error al cargar el asociado' + (detalle ? ': ' + detalle : '.');
  }

  volverAlListado() {
    this.nav.volverAlListado('/asociados');
  }

  editItem() {
    this.loading = true;
    let {fields, buttons, titleForm, mode, type} = this.formularioService.loadFormConfig(FunctionsAvailable.asociadosPut, this.buttons, this.item, 'Editar', ItemType.ASOCIADOS);
    this.fields = fields;
    this.buttons = buttons;
    this.type = type;
    this.loading = false;
    this.showEdit = true;
    // this.openItem.emit({item: this.item, type: ItemType.EJERCICIOS as ItemType, functionSelected: FunctionsAvailable.ejerciciosPut});
  }

  goBack(event?: any) {
    if (this.back.observed) {
      this.back.emit(event);
    } else {
      this.nav.volver('/asociados');
    }
  }

  handleClick(section: ViewModeAsociado) {
    this.viewMode = section;
  }

  filterItems(value: string | any) {
    value = (value.target as HTMLInputElement).value.toLowerCase();
    this.asociacionesToShow = this.asociaciones.filter(item => {
      const nombre = item.nombre ? item.nombre.toLowerCase() : '';
      const lema = item.lema ? item.lema.toLowerCase() : '';
      return item.id === Number(value) || nombre.includes(value) || lema.includes(value);
    });
  }

  agruparPorEjercicio(datos: HistoricoAsociado[]): HistoricoShow[] {
    const agrupado = datos.reduce((acc, dato) => {
      const encontrado = acc.find(historico => historico.ejercicio === dato.ejercicio);
      if (encontrado) {
        encontrado.historico.push(dato);
      } else {
        acc.push({ ejercicio: dato.ejercicio, historico: [dato] });
      }
      return acc;
    }, [] as HistoricoShow[]);
    return agrupado;
  }

}
